import { Link } from "react-router-dom";
import { ArrowUpRight, Linkedin, Instagram } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const Footer = () => (
  <footer className="border-t border-black/10" data-testid="main-footer">
    <div className="mx-auto max-w-[1600px] px-6 py-20 sm:px-12 sm:py-28">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Creative Curve Communication</p>
        <Link to="/contact" data-testid="footer-cta-link" className="group mt-6 block">
          <span className="font-syne text-[1.75rem] font-extrabold uppercase leading-[1.4] tracking-wider transition-colors duration-300 group-hover:text-primary sm:text-[2.4rem] lg:text-[3.8rem]">
            Ideas that matter.
            <br />
            Stories that move.
            <br />
            <span className="flex items-center gap-4">
              Influence that lasts.
              <ArrowUpRight className="h-10 w-10 text-primary transition-transform duration-300 group-hover:translate-x-2 group-hover:-translate-y-2 sm:h-16 sm:w-16" />
            </span>
          </span>
        </Link>
      </Reveal>

      <div className="mt-20 flex flex-col gap-10 border-t border-black/10 pt-10 sm:flex-row sm:items-end sm:justify-between">
        <div className="space-y-2 text-sm text-muted-foreground">
          <p className="text-xs uppercase tracking-[0.2em]">Strategic Communications · Creative Thinking · Meaningful Influence</p>
          <p data-testid="footer-email">hello@creative-curve.co.in</p>
          <div className="flex gap-3 pt-2">
            <a href="#" data-testid="footer-linkedin-link" aria-label="LinkedIn" className="border border-black/15 p-2.5 text-muted-foreground transition-colors duration-300 hover:border-primary hover:text-primary">
              <Linkedin className="h-4 w-4" />
            </a>
            <a href="#" data-testid="footer-instagram-link" aria-label="Instagram" className="border border-black/15 p-2.5 text-muted-foreground transition-colors duration-300 hover:border-primary hover:text-primary">
              <Instagram className="h-4 w-4" />
            </a>
          </div>
        </div>
        <nav className="flex flex-wrap gap-6 text-xs uppercase tracking-[0.2em]" data-testid="footer-nav">
          <Link to="/approach" data-testid="footer-approach-link" className="text-muted-foreground transition-colors duration-300 hover:text-primary">Approach</Link>
          <Link to="/services" data-testid="footer-services-link" className="text-muted-foreground transition-colors duration-300 hover:text-primary">Services</Link>
          <Link to="/work" data-testid="footer-work-link" className="text-muted-foreground transition-colors duration-300 hover:text-primary">Work</Link>
          <Link to="/contact" data-testid="footer-contact-link" className="text-muted-foreground transition-colors duration-300 hover:text-primary">Contact</Link>
        </nav>
      </div>
      <p className="mt-10 text-xs text-muted-foreground/60">© {new Date().getFullYear()} Creative Curve Communication. All rights reserved.</p>
    </div>
  </footer>
);
